import { Directive, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { cleanPhoneNumber, formatPhoneNumber } from '@rivethealth/data/contact';
import { DeprecatedTextFieldComponent } from './text-field.component';

@Directive({
  selector: '[phone-mask]',
})
export class PhoneMaskDirective implements OnInit {
  constructor(public ngControl: NgControl) {}

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event: any) {
    this.onInputChange(event, false);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event: KeyboardEvent) {
    this.onInputChange((<HTMLInputElement>event.target).value, true);
  }

  onInputChange(event: any, backspace: boolean) {
    this.ngControl.valueAccessor!.writeValue(this.format(event, backspace));
  }

  format(value: string, backspace: boolean) {
    let result = cleanPhoneNumber(value);
    if (backspace) {
      // delete the trailing format character
      if (result.length <= 6) {
        result = result.substring(0, result.length - 1);
        if (result.length == 0) {
          (
            this.ngControl.valueAccessor as DeprecatedTextFieldComponent
          ).propagateChange('');
        }
      }
    }
    return formatPhoneNumber(result);
  }

  ngOnInit() {
    setTimeout(() => {
      const initialOnChange = (
        this.ngControl.valueAccessor as DeprecatedTextFieldComponent
      ).propagateChange;
      (
        this.ngControl.valueAccessor as DeprecatedTextFieldComponent
      ).propagateChange = (value: any) =>
        initialOnChange(this.format(value, false));
    }, 0);
  }
}
